const subheadingsData = {
    1:[
        {
            title: "À propos de moi",
            content: (
                <>
                    <p>
                    En période de transition, envisageant des opportunités dans le développement informatique - Diplômé d'un BAC +5 en tant que Manager de Solutions Digitales et Data - Maitrise dans le développement RPA, dans l'automatisation de processus avec Python et dans la création de site web - Bon esprit d’équipe - Facilité d’adaptation - Je me considère comme un passionné de la nouvelle technologie.
                    </p>
                </>
            )
        }
    ],

    2:[
        {
            title: "2021 - 2023 / Bac+5 MS2D",
            content: (
                <>
                    <p>
                        Manager de Solutions Digitales et Data à l'IMIE PARIS.
                    </p>
                </>
            )
        },
        {
            title: "2020 - 2021 / Bac+3 CDA",
            content: (
                <>
                    <p>
                        Concepteur Développeur d'Application à l'IMIE PARIS.
                    </p>
                </>
            )
        },
        {
            title: "2018 - 2020 / Bac+2 BTS SIO",
            content: (
                <>
                    <p>
                        BTS Services Informatiques aux Organisations à l'IMIE PARIS.
                    </p>
                </>
            )
        }
    ],
    3:[
        {
            title: "2021-2023 / Développeur Python",
            content: (
                <>
                    <p>
                        Développeur Python - Automatisation de processus pour la finance chez BNP PARIBAS CARDIF.
                    </p>
                </>
            )
        },
        {
            title: "2020-2021 / Développeur VBA",
            content: (
                <>
                    <p>
                        Développeur VBA - Automatisation de processus pour la finance chez BNP PARIBAS CARDIF.
                    </p>
                </>
            )
        },
        {
            title: "2018-2020 / Développeur RPA",
            content: (
                <>
                    <p>
                        Développeur RPA - Robotisation et automatisation avec l'outil Blue Prism pour la Finance chez BNP PARIBAS CARDIF.
                    </p>
                </>
            )
        }
    ],
}

export default subheadingsData;